/** EPN-104 approved product wording. The money note is verbatim product copy — do not paraphrase. The shadow
 * warning lives in shared/shadowCalculationWarning.ts (identical to the Custom Pay Run backend string). */
export const APPROVAL_NOT_MONEY_MOVEMENT_NOTE =
  'Approving this payroll run records an approval decision in EPN. It does not itself transmit a direct deposit, make a tax payment, or file a tax return.';

export const REJECTED_IS_FINAL_NOTE =
  'A rejected payroll run is final. It cannot be edited or resubmitted — start a new Custom Pay Run and recalculate.';

/** The backend emails the run's preparer on rejection (best-effort; nothing is sent while email delivery is not enabled). */
export const REJECTION_EMAIL_NOTE =
  'The person who processed this run is notified by email that it was rejected, including your reason, when email delivery is enabled.';

/** Shown on Custom Pay Run once Payroll Review has rejected the handed-off run. */
export const CUSTOM_PAY_RUN_REJECTED_NOTE =
  "This run was rejected in Payroll Review and is final. It can't be edited or resubmitted — start a new Custom Pay Run and recalculate.";

export const READ_ONLY_NOTICE = "You don't have permission to approve or reject payroll runs.";

/** EPN-22 prompt 3. No Figma frame exists for this state (UX / DESIGN GAP); wording follows the page's existing blocked-state notes. */
export const TAX_NOT_READY_APPROVE_REASON =
  "Approve is unavailable: the tax results for some employees in this run are not approved for payroll. See the tax notice above.";

export const TAX_NOT_READY_TITLE = "This payroll can't be approved yet: some tax results are not approved for payroll";

export const TAX_NOT_READY_FIX =
  'To fix it, the tax rules must be approved in the tax engine (or the flagged tax line resolved). Then recalculate the affected employees in a new pay run: calculations in this run cannot be changed.';

/** Plain-language meaning of each server code. An unknown code is shown as is, never hidden. */
export const TAX_READINESS_CODE_LABELS: Record<string, string> = {
  TAX_RULES_NOT_PRODUCTION_READY: 'Tax rules used are not yet approved for payroll (preview result)',
  TAX_REQUIRES_REVIEW: 'A tax amount could not be determined and needs review',
  LOCAL_TAX_NOT_REQUESTED: 'Local tax was not calculated',
  TAX_READINESS_NOT_REPORTED: 'The tax engine did not report whether this result is approved for payroll',
};

/** EPN-22: the tax engine's per-employee warnings. Informational: they never block approval. No Figma frame exists (UX / DESIGN GAP). */
export const TAX_WARNINGS_TITLE = 'Tax warnings';

export const TAX_WARNINGS_INTRO =
  'The tax engine reported these notes when it calculated the employees below. They do not stop approval; check that each one is expected before you approve.';

export const TAX_WARNINGS_LOADING = 'Checking for tax warnings…';

export const TAX_WARNINGS_LOAD_FAILED = 'Tax warnings could not be loaded. Approval is not affected; you can retry.';
